import { graphql } from '@/generated/gql';

export const GET_DOCUMENT_CHUNK_BY_ID = graphql(/* GraphQL */ `
  query DocumentChunk($chunkId: UUID!) {
    sevenbridges {
      documentChunk(id: $chunkId) {
        id
        title
        content
        fileId
        documentUrl
      }
    }
  }
`);
